import backendAPI from './axiosInstance';
import Cookies from 'js-cookie';

/**
 * Generic error handler for API calls
 */
const handleApiError = (error, message) => {
  console.error(`❌ ${message}:`, error.response?.data || error.message);
  throw error;
};

/**
 * Core function: Fetch projects for the logged-in user
 * @param {number} limit - Optional limit
 */
export const fetchProjects = async (limit = null) => {
  try {
    const userId = Cookies.get('userId');
    if (!userId) throw new Error("User ID not found. Please login again.");

    const response = await backendAPI.get('/projects/');
    
    let projects = response.data.filter(project => !project.is_deleted);

    return limit ? projects.slice(0, limit) : projects;

  } catch (error) {
    handleApiError(error, "Error fetching projects");
  }
};

/**
 * Dashboard-specific fetch (keeps old imports intact)
 */
export const fetchDashboardProjects = async () => {
  return await fetchProjects(6);   // Limit to 6 for dashboard
};

/**
 * Create a new project
 */
export const createProject = async (projectData) => {
  try {
    const response = await backendAPI.post('/projects/', projectData);
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to create project");
  }
};
